// extracted by mini-css-extract-plugin
export default {"otherProducts":"tiles--otherProducts","tileGrid":"tiles--tileGrid"};